export default function isSafeClassName(className) {
  return className.indexOf('ad') === -1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela/node_modules/fela-utils/es/isSafeClassName.js
// module id = 697
// module chunks = 0